/**
 * Shopinfo — Payment Options Modal
 * Opens a bottom-sheet with PIX details and installment table
 */

(function () {
  'use strict';

  const OVERLAY_ID  = 'shopinfo-payment-overlay';
  const MODAL_ID    = 'shopinfo-payment-modal';

  function getOrCreateModal() {
    if (document.getElementById(MODAL_ID)) return;

    // Overlay
    const overlay = document.createElement('div');
    overlay.id = OVERLAY_ID;
    overlay.className = 'shopinfo-payment-modal__overlay';
    overlay.setAttribute('aria-hidden', 'true');
    overlay.addEventListener('click', closeModal);

    // Modal
    const modal = document.createElement('div');
    modal.id = MODAL_ID;
    modal.className = 'shopinfo-payment-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'shopinfo-payment-title');

    modal.innerHTML = `
      <div class="shopinfo-payment-modal__handle" aria-hidden="true"></div>

      <div class="shopinfo-payment-modal__header">
        <h2 class="shopinfo-payment-modal__title" id="shopinfo-payment-title">Formas de pagamento</h2>
        <button class="shopinfo-payment-modal__close" aria-label="Fechar" id="shopinfo-payment-close">&#x2715;</button>
      </div>

      <div class="shopinfo-payment-modal__tabs" role="tablist">
        <button
          class="shopinfo-payment-modal__tab is-active"
          role="tab"
          aria-selected="true"
          aria-controls="shopinfo-panel-pix"
          id="shopinfo-tab-pix"
          data-tab="pix"
        >PIX</button>
        <button
          class="shopinfo-payment-modal__tab"
          role="tab"
          aria-selected="false"
          aria-controls="shopinfo-panel-card"
          id="shopinfo-tab-card"
          data-tab="card"
        >Cartão de crédito</button>
      </div>

      <div class="shopinfo-payment-modal__content">

        <!-- PIX Panel -->
        <div
          class="shopinfo-payment-modal__panel is-active"
          id="shopinfo-panel-pix"
          role="tabpanel"
          aria-labelledby="shopinfo-tab-pix"
        >
          <div class="shopinfo-payment-pix__badge">
            <svg class="shopinfo-payment-pix__icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path d="M5.5 9.5L9.5 5.5C10.9 4.1 13.1 4.1 14.5 5.5L18.5 9.5C19.9 10.9 19.9 13.1 18.5 14.5L14.5 18.5C13.1 19.9 10.9 19.9 9.5 18.5L5.5 14.5C4.1 13.1 4.1 10.9 5.5 9.5Z" fill="#2e7d32"/>
            </svg>
            PIX
          </div>
          <div class="shopinfo-payment-pix__price" id="shopinfo-pix-price">—</div>
          <div class="shopinfo-payment-pix__description" id="shopinfo-pix-desc">
            Pague com o PIX com <strong id="shopinfo-pix-discount">—</strong>% de desconto e
            <em>priorizamos o despacho em 1 hora!</em>
          </div>
        </div>

        <!-- Credit Card Panel -->
        <div
          class="shopinfo-payment-modal__panel"
          id="shopinfo-panel-card"
          role="tabpanel"
          aria-labelledby="shopinfo-tab-card"
        >
          <table class="shopinfo-payment-card__table" aria-label="Parcelas no cartão de crédito">
            <thead>
              <tr>
                <th scope="col">Parcelas</th>
                <th scope="col" style="text-align:right">Valor por parcela</th>
              </tr>
            </thead>
            <tbody id="shopinfo-installments-body">
              <!-- Filled dynamically -->
            </tbody>
          </table>
          <!--
            A nota fica VAZIA aqui de proposito. Este innerHTML e montado uma
            unica vez por pagina (ver o early return de getOrCreateModal) e
            reusado em todo produto aberto na mesma navegacao — texto cravado
            aqui congelaria o do primeiro produto. Quem escreve a nota e
            openModal(), a cada abertura, com a copy que desce do Liquid em
            data-installments-note.
          -->
          <p class="shopinfo-payment-card__note" id="shopinfo-installments-note"></p>
        </div>

      </div>
    `;

    document.body.appendChild(overlay);
    document.body.appendChild(modal);

    // Tab switching
    modal.querySelectorAll('.shopinfo-payment-modal__tab').forEach(tab => {
      tab.addEventListener('click', () => switchTab(tab.dataset.tab));
    });

    // Close button
    modal.querySelector('#shopinfo-payment-close').addEventListener('click', closeModal);

    // Keyboard ESC
    document.addEventListener('keydown', onKeydown);
  }

  function switchTab(name) {
    const modal = document.getElementById(MODAL_ID);
    modal.querySelectorAll('.shopinfo-payment-modal__tab').forEach(t => {
      const active = t.dataset.tab === name;
      t.classList.toggle('is-active', active);
      t.setAttribute('aria-selected', active);
    });
    modal.querySelectorAll('.shopinfo-payment-modal__panel').forEach(p => {
      p.classList.toggle('is-active', p.id === `shopinfo-panel-${name}`);
    });
  }

  function openModal(pixPrice, pixDiscount, basePrice, maxInstallments = 1, installmentsNote = '') {
    getOrCreateModal();

    const modal   = document.getElementById(MODAL_ID);
    const overlay = document.getElementById(OVERLAY_ID);

    // Populate PIX info
    document.getElementById('shopinfo-pix-price').textContent    = pixPrice;
    document.getElementById('shopinfo-pix-discount').textContent = pixDiscount;

    // A nota e a tabela sao reescritas a CADA abertura: o modal e um so por
    // pagina e serve todos os produtos abertos na mesma navegacao (carrossel de
    // similares da PDP). A copy vem pronta do Liquid — nao ha texto em portugues
    // do parcelamento neste arquivo.
    const noteEl = document.getElementById('shopinfo-installments-note');
    if (noteEl) noteEl.textContent = installmentsNote || '';

    // Populate installments table
    const tbody  = document.getElementById('shopinfo-installments-body');
    tbody.innerHTML = '';
    const cents = parseInt(basePrice, 10) || 0;
    const maxN  = parseInt(maxInstallments, 10) || 1;

    for (let i = 1; i <= maxN; i++) {
      // Teto em centavos inteiros, identico ao `plus: n | minus: 1 | divided_by: n`
      // do Liquid. Dividir em float e arredondar no toLocaleString dava divergencia
      // de centavo entre a linha da PDP e esta tabela, a um clique de distancia.
      const installmentValue = Math.ceil(cents / i);
      const tr = document.createElement('tr');
      tr.innerHTML = `
        <td>${i}x</td>
        <td>${formatMoney(installmentValue)}</td>
      `;
      tbody.appendChild(tr);
    }

    // Switch to PIX tab by default
    switchTab('pix');

    // Show
    overlay.classList.add('is-open');
    overlay.removeAttribute('aria-hidden');
    requestAnimationFrame(() => {
      modal.style.display = 'flex';
      requestAnimationFrame(() => modal.classList.add('is-open'));
    });

    document.body.style.overflow = 'hidden';

    // Focus trap: focus the close button
    setTimeout(() => {
      const closeBtn = document.getElementById('shopinfo-payment-close');
      if (closeBtn) closeBtn.focus();
    }, 350);
  }

  function closeModal() {
    const modal   = document.getElementById(MODAL_ID);
    const overlay = document.getElementById(OVERLAY_ID);
    if (!modal || !overlay) return;

    modal.classList.remove('is-open');
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';

    setTimeout(() => {
      modal.style.display = '';
    }, 320);
  }

  function onKeydown(e) {
    if (e.key === 'Escape') closeModal();
  }

  function onPaymentCtaClick(e) {
    const button = e.target.closest('.shopinfo-payment-cta');
    if (!button) return;

    e.preventDefault();

    const priceBlock = button.closest('.shopinfo-pdp-price-block');
    const pixPriceElement = priceBlock?.querySelector('.shopinfo-price__pix-hero');
    const pixPrice = pixPriceElement ? pixPriceElement.textContent.trim() : '';

    openModal(
      pixPrice,
      button.dataset.pixDiscount,
      button.dataset.basePrice,
      button.dataset.maxInstallments,
      button.dataset.installmentsNote
    );
  }

  function formatMoney(cents) {
    // cents here is already in subunit (Shopify stores prices as integers ÷ 100)
    const formatted = (cents / 100).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });
    return formatted;
  }

  if (!window.shopinfoPaymentModalBound) {
    window.shopinfoPaymentModalBound = true;
    document.addEventListener('click', onPaymentCtaClick);
  }

  // Keep the global API available for backwards compatibility.
  window.shopinfoOpenPaymentModal = openModal;
  window.shopinfoClosePaymentModal = closeModal;
})();
